import type { Restriction } from 'lumen/models';
import {
  RESTRICTION_TYPE_NONE,
  RESTRICTION_TYPES,
} from 'lumen/utils/constants/channel-pricing-constants';
import type { RestrictionActionValue } from 'lumen/utils/constants/restriction-actions';

export function prepareRestrictionActionPayload(
  restrictionType: string,
  restrictionValue: number | undefined,
  currentRestriction: Restriction | undefined,
): RestrictionActionValue[] | null {
  // Extra logic to map the selected restriction value in our UI to the necessary restriction actions that BE needs
  // Scenarios:
  //         When the current restriction is "Closed":
  //            - If the user selects "Open" -> send "Open" (CLOSED and value 0) + MIN_LOS and LOS value 1
  //            - If the user selects "MIN_LOS" -> send "Open" (CLOSED and value 0) + MIN_LOS and the LOS value
  //         When the current restriction is "MIN_LOS" or "Open":
  //            - If the user selects "Open" -> send MIN_LOS and LOS value 1
  //            - If the user selects "MIN_LOS" -> send MIN_LOS and the LOS value
  //            - If the user selects "Closed" -> send CLOSED and value 1
  if (
    currentRestriction &&
    currentRestriction.values[0]?.type === RESTRICTION_TYPES.CLOSED
  ) {
    if (
      restrictionType === RESTRICTION_TYPE_NONE ||
      (restrictionType === RESTRICTION_TYPES.CLOSED && restrictionValue === 0)
    ) {
      return [
        {
          type: RESTRICTION_TYPES.CLOSED,
          value: 0,
        },
        {
          type: RESTRICTION_TYPES.MIN_LOS,
          value: 1,
        },
      ];
    }
    if (restrictionType === RESTRICTION_TYPES.MIN_LOS) {
      return [
        {
          type: RESTRICTION_TYPES.CLOSED,
          value: 0,
        },
        {
          type: restrictionType,
          value: restrictionValue,
        },
      ];
    }
  } else if (
    (currentRestriction &&
      currentRestriction.values[0]?.type === RESTRICTION_TYPES.MIN_LOS) ||
    !currentRestriction || // No current restriction being present can be seen as an "open" state
    currentRestriction.hasNoValues // It's possible that a restriction record is present to deliver a message to FE, but without values. Also treat this as "open".
  ) {
    if (
      restrictionType === RESTRICTION_TYPE_NONE ||
      (restrictionType === RESTRICTION_TYPES.CLOSED && restrictionValue === 0)
    ) {
      return [
        {
          type: RESTRICTION_TYPES.MIN_LOS,
          value: 1,
        },
      ];
    }
    if (restrictionType === RESTRICTION_TYPES.MIN_LOS) {
      return [
        {
          type: restrictionType,
          value: restrictionValue,
        },
      ];
    }
    if (restrictionType === RESTRICTION_TYPES.CLOSED) {
      return [
        {
          type: RESTRICTION_TYPES.CLOSED,
          value: 1,
        },
      ];
    }
  }

  return null;
}
